import httpManager from "@/app/shared/utils/httpManager";

/**
 * @param {Number} chatbotId
 * @param {Object} body
 */

export async function deleteChatbot(chatbotId) {
  await httpManager.delete(`/chatbots/${chatbotId}/`);
}
